/// <amd-module name="VSSUI/Components/IdentityCard/ContactCard" />
import * as React from "react";
import { Link } from "VSSUI/Link";
import * as Resources from "VSSUI/Resources.Persona";
import { css } from "VSSUI/Util";
import { IContactCardContactLineProps, IContactCardProps } from "./ContactCard.Props";

export const ContactCardContactLine: React.FunctionComponent<IContactCardContactLineProps> = (props: IContactCardContactLineProps) => {
    const { content, label, link, padTop } = props;
    return (
        <div className="flex-column scroll-hidden">
            <div className={css("bolt-identity-contact-card-line flex-row flex-grow", padTop && "bolt-identity-contact-card-line-top")}>
                <div className="bolt-identity-contact-card-span-label flex-noshrink">{label}</div>
                <div className="bolt-identity-contact-card-span-content flex-grow flex-row">
                    {link && content && (
                        <Link className="flex-row text-ellipsis" href={link}>
                            {content}
                        </Link>
                    )}
                    {!link && content}
                </div>
            </div>
        </div>
    );
};

export const ContactCard: React.FunctionComponent<IContactCardProps> = (props: IContactCardProps) => {
    const { identity } = props;

    return (
        <div className="bolt-bolt-identity-contact-card-organization-card-wrapper flex-column scroll-hidden">
            <div className="bolt-identity-contact-card-header-wrapper">
                <div className="body-m">{Resources.IdentityCardContactInfo}</div>
            </div>
            <div className="bolt-identity-contact-card-info-wrapper flex-column flex-grow body-s">
                <ContactCardContactLine label={Resources.IdentityCardEmail} content={identity.mail} link={`mailto:${identity.mail}`} />
                <ContactCardContactLine
                    content={identity.telephoneNumber}
                    label={Resources.IdentityCardPhoneNumber}
                    link={`mailto:${identity.telephoneNumber}`}
                />
                <ContactCardContactLine label={Resources.IdentityCardLocation} content={identity.physicalDeliveryOfficeName} />
                <ContactCardContactLine label={Resources.IdentityCardTitle} content={identity.jobTitle} padTop={true} />
                <ContactCardContactLine label={Resources.IdentityCardDepartment} content={identity.department} />
                <ContactCardContactLine label={Resources.IdentityCardAlias} content={identity.mailNickname} />
            </div>
        </div>
    );
};
